import React, {useState} from 'react';
import { Grid } from '@mui/material';
import SessionConstants from '../../config/SessionConstants';
import './cdc-template.css';
import './index.css';

export default function CdcHeader() {
    //check session for fullscreen setting
    const [fullscreen] = useState(JSON.parse(sessionStorage.getItem(SessionConstants.FULLSCREEN)));

    return (
        <div className="header-wrapper theme-cyan">
            <div className={ fullscreen? 'container-wide container-head' : 'container container-head'}>
                <header role="banner" aria-label="Header" className="pt-2 pb-2">
                    <div className="">
                        <Grid container spacing={0} className="dashGridContainer">
                            <Grid item xs={8}>
                                <div className="cdc-logo">
                                    <span className="sr-only">Centers for Disease Control and Prevention</span>
                                    <a href="https://www.cdc.gov">
                                    <img src="/images/cdc-logo-text-bottom.png" alt="CDC Logo" /> 
                                    </a>
        
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div className="tp-search">
                                    <div className="headerSearch cdc-header-search">
                                        <form acceptCharset="UTF-8" action="//search.cdc.gov/search/index.html" method="get" autoComplete="off">
                                            <button className="btn btn-primary dropdown-toggle no-toggle search-button ssi d-xl-none" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label="search">
                                                <span>Search</span>
                                                <i className="fi cdc-icon-magnify dropdown-menu-medium-search-icon x24" aria-hidden="true"></i>
                                                <i className="fi cdc-icon-close dropdown-menu-medium-close-icon x24" aria-hidden="true"></i>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right dropdown-menu-search dropdown-menu-medium-search">
                                                <div className="input-group">
                                                    <input id="headerSearch" type="text" className="form-control" maxLength="300" placeholder="Search" aria-label="Search" name="query" />
                                                    <span className="form-control-clear cdc-icon-close" style={{"visibility": "hidden"}}></span>
                                                    <div className="input-group-append">
                                                        <button className="btn search-submit" type="submit"><span className="sr-only">Submit</span>
                                                            <i className="fi cdc-icon-magnify x24" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="a-z-index fs0875">
                                                    <span className="d-xl-none">For a full list of topics: </span><a id="az-large" href="https://www.cdc.gov/az/">A-Z Index</a>
                                                </div>
                                                <div className="fs0875 d-md-none">
                                                    <a href="//search.cdc.gov/search/index.html#advanced">
                                                        Advanced Search
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="fs0875 d-none d-md-block tp-search-advanced">
                                                <a href="//search.cdc.gov/search/index.html#advanced">
                                                    Advanced Search
                                                </a>
                                            </div>
                                            <input type="hidden" name="sitelimit" value=""/>
                                            <input type="hidden" name="utf8" value="✓"/>
                                            <input type="hidden" name="affiliate" value="cdc-main"/>
                                        </form>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </header>
            </div>
        </div>
    );
  }